import PatientLayoutMain from "./PatientLayoutMain";
import Overview from "../Overview";
import { Outlet, useMatch, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPatientDetails, fetchAllergy } from "../../../redux/modules/patient/actions";
import { useEffect } from "react";
import {
  fetchClinicalServices,
  fetchMedicalConditions,
  fetchMedications,
} from "../../../redux/modules/clinical-services/actions";
import { setDefaultMedicationsFilters } from "../../../redux/modules/medications/actions";

const PatientLayout = () => {
  const { patient } = useSelector((state) => state.patients);
  const { id } = useParams();
  const isFormViewer = useMatch(
    "/patient/:id/clinical-services/:serviceId/form/:formType"
  );
  const isSummaryFormViewer = useMatch(
    "/patient/:id/medical-summary/:type/:summaryId/form/:formType"
  );
  const isInterventionFormViewer = useMatch(
    "/patient/:id/interventions/:interventionId/:type/form/:formType"
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPatientDetails(id));
    dispatch(fetchAllergy(id));
    dispatch(fetchMedicalConditions(id));
    dispatch(fetchClinicalServices(id));
    dispatch(fetchMedications(id));
    dispatch(setDefaultMedicationsFilters());
  }, [dispatch]);

  if (isFormViewer || isSummaryFormViewer || isInterventionFormViewer) {
    return (
      <div
        style={{
          background: "url(/images/overview-image.png)",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      >
        <Overview patient={patient} isFormViewer={true} />
        <Outlet />
      </div>
    );
  }

  return (
    <>
      {patient && <Overview patient={patient} />}
      <PatientLayoutMain>
        <Outlet />
      </PatientLayoutMain>
    </>
  );
};

export default PatientLayout;
